import React from 'react'
import clsx from 'clsx'
import { useLocation } from 'react-router-dom'
import { checkIsActive, WithChildren } from '../../../../helpers'
import { getMenuIcon } from './menuIcon'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const SidebarMenuItemWithSub: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)

  return (
    <div
      className={clsx('menu-item admin-nav-item', { 'here show': isActive }, 'menu-accordion')}
      data-kt-menu-trigger="click"
    >
      <span className="menu-link">
        {hasBullet && (
          <span className="menu-bullet">
            <span className="bullet bullet-dot"></span>
          </span>
        )}
        {(icon || fontIcon || !hasBullet) && (
          <span className="menu-icon">
            <i className={clsx('bi fs-3', getMenuIcon(to, title, fontIcon))} aria-hidden="true" />
          </span>
        )}
        <span className="menu-title">{title}</span>
        <span className="menu-arrow"></span>
      </span>
      <div
        className={clsx('menu-sub menu-sub-accordion', {
          'menu-active-bg': isActive,
        })}
      >
        {children}
      </div>
    </div>
  )
  
}

export { SidebarMenuItemWithSub }
